import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchSellersCatalogData,
  fetchCateloguesData,
  getProductDetailsById,
  getCatalogueForQuickCommerce,
  getSearchRecord,
  fetchTagsData
} from "../api/ApiService";

export const initialState = {
  loading: false,
  hasErrors: false,
  status: false,
  data: [],
  catalogues: [],
  sellerDetails: {},
  searchedcatalogues: [],
  catalogueStatus: "loading",
  searchCatalogueStatus: "loading",
  getProductDetailsLoading: false,
  productDetails: null,
  catalogDataArray: [],
  similarProducts: [],
  catalogueCount: 0,
  cartItems: JSON.parse(localStorage.getItem("cart")) || [],
  quickCommerceCataloguesLoading: false,
  quickCommerceCatalogues: [],
  searchInputValue: "",
  activeCategories: [],
  searchChipsStatus: "loading",
  searchChips: [],
};

export const catalogSlice = createSlice({
  name: "catalog",
  initialState,
  reducers: {
    startLoading: (state, action) => {
      state.loading = action.payload;
    },
    updateCartItem: (state, action) => {
      state.cartItems = action?.payload || [];
    },
    setSearchInputValue: (state, action) => {
      state.searchInputValue = action.payload || "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSellersCatalog.pending, (state) => {
        state.hasErrors = false;
        state.catalogueStatus = "loading";
      })
      .addCase(fetchSellersCatalog.fulfilled, (state, action) => {
        state.catalogues = action?.payload?.data?.results || [];
        state.sellerDetails = action?.payload?.data?.sellerData || {};
        state.catalogueStatus = "loaded";
        state.catalogueCount = action?.payload?.data?.catalogueCount || 0;
      })
      .addCase(fetchSellersCatalog.rejected, (state, action) => {
        state.hasErrors = true;
        state.catalogues = [];
        state.sellerDetails = action?.payload?.data?.sellerData || {};
        state.catalogueStatus = "error";
      })
      .addCase(fetchCatelogues.pending, (state) => {
        state.hasErrors = false;
        state.searchCatalogueStatus = "loading";
      })
      .addCase(fetchCatelogues.fulfilled, (state, action) => {
        if (action?.payload?.data) {
          state.searchedcatalogues = action?.payload?.data;
          state.searchCatalogueStatus = "loaded";
        }
      })
      .addCase(fetchCatelogues.rejected, (state) => {
        state.hasErrors = true;
        state.searchCatalogueStatus = " error";
      })
      .addCase(getProductDetails.pending, (state) => {
        state.hasErrors = false;
        state.getProductDetailsLoading = true;
      })
      .addCase(getProductDetails.fulfilled, (state, action) => {
        state.productDetails = action?.payload?.data;
        state.catalogDataArray = action?.payload?.catalogDataArray;
        state.similarProducts = action?.payload?.similarProducts;
        state.getProductDetailsLoading = false;
      })
      .addCase(getProductDetails.rejected, (state) => {
        state.hasErrors = true;
        state.getProductDetailsLoading = false;
      })
      .addCase(getCataloguesForQuickCommerce.pending, (state) => {
        state.hasErrors = false;
        state.catalogueStatus = "loading";
        state.quickCommerceCataloguesLoading = true;
      })
      .addCase(getCataloguesForQuickCommerce.fulfilled, (state, action) => {
        state.catalogues = action?.payload?.data?.results || [];
        localStorage.setItem(
          "sellerDetails",
          JSON.stringify(action?.payload?.data?.sellerData[0])
        );
        state.catalogueStatus = "loaded";
        state.activeCategories = action?.payload?.data?.activeCategories || []
        state.catalogueCount = action?.payload?.data?.catalogueCount || 0;
      })
      .addCase(getCataloguesForQuickCommerce.rejected, (state) => {
        state.hasErrors = true;
        state.catalogueStatus = " error";
        state.quickCommerceCataloguesLoading = false;
      })
    builder
      .addCase(fetchTags.pending, (state) => {
        state.searchChipsStatus = "loading"; // Handles the loading state
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.searchChipsStatus = "loaded"; // Handles the success state
        state.searchChips = action.payload?.tagNames || []; // Safely set tagNames, fallback to an empty array if undefined
      })
      .addCase(fetchTags.rejected, (state) => {
        state.searchChipsStatus = "error"; // Handles the error state
      });
  },
});

export const fetchSellersCatalog = createAsyncThunk(
  "seller/fetchSellersCatalog",
  async (body) => {
    const data = await fetchSellersCatalogData(body);
    return data;
  }
);

export const fetchCatelogues = createAsyncThunk(
  "seller/fetchCatelogues",
  async (body) => {
    const data = await fetchCateloguesData(body);
    return data;
  }
);

export const fetchTags = createAsyncThunk(
  "seller/fetchTags",
  async (body) => {
    const data = await fetchTagsData(body);
    return data;
  }
);

export const getProductDetails = createAsyncThunk(
  "seller/getProductDetails",
  async (body) => {
    const data = await getProductDetailsById(body);
    return data;
  }
);

export const getCataloguesForQuickCommerce = createAsyncThunk(
  "seller/getCatalogueForQuickCommerce",
  async (body) => {
    const data = await getCatalogueForQuickCommerce(body);
    return data;
  }
);

export const getSearchRecords = async (body) => {
  if (body?.search !== "") {
    const data = await getSearchRecord(body);
    return data;
  }
}


export const {
  startLoading,
  getCatalogSuccess,
  getCatalogFailure,
  updateCartItem,
  setSearchInputValue,
} = catalogSlice.actions;

export default catalogSlice.reducer;
